import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";

const JENIS = [["gaji", "Gaji/Honor"], ["usaha", "Usaha/Pekerjaan Bebas"], ["investasi", "Investasi/Bunga"], ["sewa", "Sewa"], ["hadiah", "Hadiah/Hibah"], ["lainnya", "Lainnya"]];
const PERLAKUAN = [["progresif", "Objek Pajak (Progresif)"], ["final", "PPh Final"], ["bukan_objek", "Bukan Objek Pajak"], ["bukan_penghasilan", "Bukan Penghasilan (Titipan/Pinjaman)"]];

// Aturan pajak otomatis per kategori pemasukan (workspace pribadi)
export function PajakDefaultFields({ value, onChange }) {
  const v = value || {};
  const set = (k) => (x) => onChange({ ...v, [k]: x === "none" ? null : x });
  return (
    <div className="space-y-2 rounded-md border border-slate-200 p-3" data-testid="kat-pajak-default">
      <div className="text-xs text-slate-500">Aturan pajak otomatis — terisi sendiri saat kategori ini dipilih di Pemasukan.</div>
      <Select value={v.pajak_jenis || "none"} onValueChange={set("pajak_jenis")}>
        <SelectTrigger data-testid="kat-pajak-jenis"><SelectValue placeholder="Jenis penghasilan"/></SelectTrigger>
        <SelectContent><SelectItem value="none">— Tidak diatur —</SelectItem>{JENIS.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
      </Select>
      <Select value={v.pajak_perlakuan || "none"} onValueChange={set("pajak_perlakuan")}>
        <SelectTrigger data-testid="kat-pajak-perlakuan"><SelectValue placeholder="Perlakuan pajak"/></SelectTrigger>
        <SelectContent><SelectItem value="none">— Tidak diatur —</SelectItem>{PERLAKUAN.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
      </Select>
      {v.pajak_perlakuan === "final" && (
        <Input type="number" step="0.01" value={v.pajak_tarif ?? ""} placeholder="Tarif final % (mis. 0.5 / 10 / 20)"
          onChange={(e) => onChange({ ...v, pajak_tarif: e.target.value === "" ? null : Number(e.target.value) })} data-testid="kat-pajak-tarif"/>
      )}
    </div>
  );
}
